module.exports = __webpack_public_path__ + "img/homepage_background.f4c0a60a.jpg";